module.exports = __webpack_public_path__ + "34aef7f8a23e11e24ec5a474a04c6dd1.pdf";